module.exports = [{
      plugin: require('../.yarn/__virtual__/gatsby-plugin-image-virtual-f8274eea2d/0/cache/gatsby-plugin-image-npm-2.7.0-db833a557a-4ae8ee1a9c.zip/node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../.yarn/__virtual__/gatsby-plugin-offline-virtual-b1db0c5b93/0/cache/gatsby-plugin-offline-npm-5.7.0-d690b6020d-b65ccefe44.zip/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../.yarn/__virtual__/gatsby-plugin-manifest-virtual-64c77b654a/0/cache/gatsby-plugin-manifest-npm-4.7.0-641c792edd-94c57f4647.zip/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"rona","short_name":"rona","start_url":"/","background_color":"#fdfdfd","theme_color":"#fdfdfd","display":"minimal-ui","icon":"E:\\00work\\gatsby-rona\\client/src/assets/icons/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"93f7480e048689ba766cc86f9bd93e5c"},
    },{
      plugin: require('../.yarn/cache/gatsby-plugin-anchor-links-npm-1.2.1-7db63a8548-373724406b.zip/node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-50},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
